define(["app/app"], app => {
  const _ = require("underscore");

  app.register.controller("snapshot", [
    "$scope",
    "$rootScope",
    "data",
    "$routeParams",
    function ($scope, $rootScope, data, $routeParams) {
      if (!$scope.isAuth()) return;
      $scope.loaded = false;
      $scope.tab = null;
      $scope.currentTabId = parseInt($routeParams.tabId, 10) || undefined;

      $scope.control = {
        order: [
          { display: "Revenue", value: "REVENUE" },
          { display: "eCPM", value: "ECPM" }
        ]
      };

      $scope.setLoaded = function (loaded) {
        $scope.loaded = loaded;
      };

      $scope.fetchPublisherData = function (choosenPublisherId) {
        let pubID = $scope.currentUser().publisher_id || choosenPublisherId;
        data.getPublisher(pubID).then(res => {
          $scope.selectedPublisher = res.data;
          let type = "";
          if ($scope.selectedPublisher) {
            if ($scope.selectedPublisher.type === "SMARTWRAPPER") {
              type = "SMARTWRAPPER";
            } else if ($scope.selectedPublisher.type === "NETWORK") {
              type = "NETWORK";
            } else if ($scope.selectedPublisher.type === "COMBO") {
              type = "BOTH";
            }
          }

          data.getDashboards(type).then(res => {
            $scope.dashboards = res.data;
            let firstDashboard;
            if ($scope.currentTabId) firstDashboard = _.findWhere($scope.dashboards, { id: $scope.currentTabId });
            if (!firstDashboard) firstDashboard = _.first($scope.dashboards);
            if (firstDashboard) $scope.switchTab(firstDashboard.id);
          });
        });
      };

      $scope.fetchPublisherData();

      $scope.findDashboard = function (id) {
        for (let i = 0; i < $scope.dashboards.length; i++) {
          if ($scope.dashboards[i].id === id) {
            return $scope.dashboards[i];
          }
        }
      };

      $scope.switchTab = function (dashboardId) {
        $scope.currentTabId = dashboardId;
        let dashboard = $scope.findDashboard(dashboardId);
        $scope.tab = dashboard.name;
      };

      $scope.changeTab = function (dashboardId) {
        $rootScope.setPath(`/dashboard/${dashboardId}`);
      };

      $scope.isSelectedPublisher = function () {
        return !_.isEmpty($scope.selectedPublisher);
      };
    }
  ]);
});
